"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_WIDTH = exports.SELECT_TITLE_POSITION = exports.SELECT_SEGMENT = exports.COMPONENT_NAME = void 0;
exports.default = Select;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.hooks-utils");
var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");
require("./Select.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const SELECT_WIDTH = {
  SHORT: 'short',
  MEDIUM: 'medium',
  LARGE: 'large',
  LIQUID: 'liquid',
  FULL: 'full'
};
exports.SELECT_WIDTH = SELECT_WIDTH;
const SELECT_SEGMENT = {
  GP: 'particulares',
  EMP: 'empresas',
  DEFAULT: ''
};
exports.SELECT_SEGMENT = SELECT_SEGMENT;
const SELECT_TITLE_POSITION = {
  LEFT: 'left',
  TOP: 'top'
};
exports.SELECT_TITLE_POSITION = SELECT_TITLE_POSITION;
const COMPONENT_NAME = 'Select';
exports.COMPONENT_NAME = COMPONENT_NAME;
function Select(_ref) {
  let {
    name,
    title,
    hideTitle,
    options,
    defaultValue,
    onChange,
    formSkeletonProps,
    error,
    placeholder,
    className,
    width,
    segment,
    required,
    taggingInfo = {},
    isSearchable,
    titlePosition
  } = _ref;
  const {
    submitTries,
    activateFormElement,
    deactivateFormElement,
    validateFormElement,
    validateForm
  } = _objectSpread({}, formSkeletonProps);
  (0, _gerenciatdUtils.useFormSkeletonSubscribe)(activateFormElement, deactivateFormElement);
  const prevSubmitTries = (0, _gerenciatdUtils.usePreviousConditioned)(submitTries, validateForm);
  const getValueObjFromValueStr = (value, array) => {
    const occurrences = array.filter(element => element.value === value);
    if (occurrences.length === 1) {
      return occurrences[0];
    }
    return null;
  };
  const [selectedOption, setSelectedOption] = (0, _react.useState)(getValueObjFromValueStr(defaultValue, options));
  const [validationError, setValidationError] = (0, _react.useState)('');
  const finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
    componentVariation: taggingInfo.componentVariation || 'all',
    componentProduct: taggingInfo.componentProduct || '',
    componentName: taggingInfo.componentName || COMPONENT_NAME,
    eventType: 'click'
  });
  const handleChange = element => {
    const {
      value,
      label
    } = element;
    (0, _gerenciatdUtils2.sendCMSEvent)(_objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
      componentContent: `select-${name}-position-${options.findIndex(option => option === element)}`
    }));
    setSelectedOption(element);
    setValidationError('');
    if (onChange) {
      onChange(value, label);
    }
  };

  /**
   * Detecta cambios en DefuaultValue y la reestablece
   */
  (0, _react.useEffect)(() => {
    setSelectedOption(getValueObjFromValueStr(defaultValue, options));
  }, [defaultValue]);
  (0, _react.useEffect)(() => {
    setValidationError(error);
  }, [error]);
  (0, _react.useEffect)(() => {
    if (formSkeletonProps) {
      let validationObj = {};
      if (prevSubmitTries !== submitTries && submitTries > 0) {
        if (!selectedOption && required) {
          validationObj = {
            validated: false,
            errorMsg: 'Por favor, rellena este campo'
          };
        } else {
          validationObj = {
            validated: true,
            errorMsg: ''
          };
        }
        setValidationError(validationObj.errorMsg);
        validateFormElement(validationObj);
      }
    }
  }, [submitTries, prevSubmitTries]);
  let colorValidation = 'blue';
  if (validationError) {
    colorValidation = 'red';
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `e-skeletonSelect ${segment ? `e-skeletonSelect--${segment}` : ''} e-skeletonSelect__width--${width} ${className} e-skeletonSelect__titlePosition--${titlePosition}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "e-skeletonSelect__labelContainer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        htmlFor: name,
        className: `e-skeletonSelect__label ${hideTitle ? 'hide-acc' : ''}`,
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "e-skeletonSelect__selectContainer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.default, {
        id: name,
        name: name,
        options: options,
        value: selectedOption,
        placeholder: placeholder,
        onChange: handleChange,
        className: `react-select__container react-select__container--${colorValidation}`,
        classNamePrefix: "react-select",
        clearable: true,
        isSearchable: isSearchable
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "e-skeletonSelect__error",
      children: validationError || '\u00A0'
    })]
  });
}
Select.propTypes = {
  /**
   * {
   *  "info": "Nombre que tomará el elemento en el DOM",
   *  "kind": "both",
   *  "beautifulName": "Name"
   * }
   */
  name: _propTypes.default.string.isRequired,
  /**
   * {
   *  "info": "Texto que aparecerá como label del select",
   *  "kind": "both",
   *  "beautifulName": "Titulo"
   * }
   */
  title: _propTypes.default.string.isRequired,
  /**
   * {
   *  "info": "Marca para decidir si el título será visible o no",
   *  "kind": "both",
   *  "beautifulName": "OcultarTítulo"
   * }
   */
  hideTitle: _propTypes.default.bool,
  /**
   * {
   *  "info": "Listado de elementos del select",
   *  "kind": "both",
   *  "beautifulName": "Opciones"
   * }
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,
  /**
   * {
   *  "info": "Valor preseleccionado del select",
   *  "kind": "both",
   *  "beautifulName": "ValorPorDefecto"
   * }
   */
  defaultValue: _propTypes.default.string,
  /**
   * {
   *  "info": "Función ejecutada ante un cambio de la elección en el select",
   *  "kind": "both",
   *  "beautifulName": "onChange"
   * }
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * {
   *  "info": "Propiedades de formSkeleton necesarias para su integración con este componente",
   *  "kind": "both",
   *  "beautifulName": "formSkeletonProps"
   * }
   */
  formSkeletonProps: _propTypes.default.shape({
    submitTries: _propTypes.default.number.isRequired,
    validationTries: _propTypes.default.number.isRequired,
    activateFormElement: _propTypes.default.func.isRequired,
    deactivateFormElement: _propTypes.default.func.isRequired,
    validateFormElement: _propTypes.default.func.isRequired,
    validateForm: _propTypes.default.bool.isRequired
  }),
  /**
   * {
   *  "info": "Error a mostrar forzado desde el padre",
   *  "kind": "both",
   *  "beautifulName": "Error"
   * }
   */
  error: _propTypes.default.string,
  /**
   * {
   *  "info": "Texto a mostrar como placeholder del select",
   *  "kind": "both",
   *  "beautifulName": "Placeholder"
   * }
   */
  placeholder: _propTypes.default.string,
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "ClassName"
   * }
   */
  className: _propTypes.default.string,
  /**
   * {
   *  "info": "Define el ancho que tendrá el componente",
   *  "kind": "both",
   *  "beautifulName": "Ancho"
   * }
   */
  width: _propTypes.default.oneOf(Object.values(SELECT_WIDTH)),
  /**
   * {
   *  "info": "Define el segmento donde estará el componente",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf(Object.values(SELECT_SEGMENT)),
  /**
   * {
   *  "info": "Define si es obligatorio realizar una elección en el select o no",
   *  "kind": "both",
   *  "beautifulName": "Requerido"
   * }
   */
  required: _propTypes.default.bool,
  /**
   * {
   *  "info": "Puede realizarse una busqueda dentro del Select",
   *  "kind": "both",
   *  "beautifulName": "Buscador"
   * }
   */
  isSearchable: _propTypes.default.bool,
  titlePosition: _propTypes.default.string
};
Select.defaultProps = {
  hideTitle: false,
  defaultValue: '',
  formSkeletonProps: null,
  error: '',
  placeholder: 'Selecciona una opción',
  className: '',
  width: SELECT_WIDTH.MEDIUM,
  segment: SELECT_SEGMENT.DEFAULT,
  required: false,
  isSearchable: false,
  titlePosition: SELECT_TITLE_POSITION.TOP
};

//# sourceMappingURL=index.js.map